var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardMask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355,
    height: 255.496,
    viewBox: "0 0 355 255.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_5",
    x: 26.999,
    y: 8.504,
    width: 297.999,
    height: 246.991,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5ed6ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mask",
    x: 70.385,
    y: 50.902,
    width: 209.6,
    height: 172.121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Mask",
    "data-name": "Dashboard Mask",
    transform: "translate(-1326 -58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2",
    "data-name": "Mask",
    transform: "translate(-153 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Mask-2",
    "data-name": "Dashboard Mask",
    transform: "translate(1248 -9.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 231, 53)",
    filter: "url(#Exclusion_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_5-2",
    "data-name": "Exclusion 5",
    d: "M-14815-5154.508h-262V-5365.5h262v210.99Zm-131.752-14.58h0c.115,0,.242.007.375.007,2.872,0,5.8-1.2,8.717-3.579.975-.818,1.955-1.668,2.819-2.418l.009-.007a80.507,80.507,0,0,1,8.728-6.878c6.512-4.215,13.63-7.557,20.513-10.789l.012-.005a182.435,182.435,0,0,0,19.426-10.092,62.562,62.562,0,0,0,16.656-14.542c4.568-5.86,8.708-13.007,13.027-22.491,14.192-31.442,18.034-65.776,10.818-96.677-.146-1.216-.331-2.353-.494-3.356l0-.027c-.027-.171-.055-.339-.081-.5l-.038-.238a.352.352,0,0,0-.376-.315.458.458,0,0,0-.482.437c.031,1.376.181,2.888.338,4.488.462,4.693.985,10.012-1.261,13.689a5.952,5.952,0,0,1-5.271,3.1c-2,0-4.411-.845-7.173-2.512a55.419,55.419,0,0,1-6.057-4.406c-.7-.572-1.408-1.153-2.13-1.747-7.712-6.35-15.686-12.916-26.385-12.916-10.308,0-19.748,4.276-30.607,13.864-.7.619-1.4,1.225-2.149,1.866l-.109.094c-3.717,3.189-7.56,6.487-9.85,10.67-.275.5-.545,1.023-.8,1.53l-.045.087c-1.252,2.443-2.547,4.97-5.109,6.329a11.636,11.636,0,0,1-3.076,1.173,11.658,11.658,0,0,1-3.073-1.173c-2.457-1.328-3.748-3.787-5-6.164-.311-.591-.629-1.2-.963-1.782-2.354-4.213-6.208-7.532-9.935-10.741l-.007-.005-.006-.005c-.717-.618-1.458-1.256-2.161-1.878-10.939-9.588-20.38-13.864-30.607-13.864-10.6,0-18.516,6.48-26.166,12.746-.754.619-1.561,1.279-2.349,1.916a55.362,55.362,0,0,1-6.057,4.406c-2.762,1.667-5.175,2.513-7.172,2.513a5.95,5.95,0,0,1-5.271-3.1c-2.247-3.677-1.724-9-1.262-13.689.158-1.607.308-3.125.338-4.488a.458.458,0,0,0-.482-.437.352.352,0,0,0-.376.315c-.059.391-.117.8-.179,1.225l-.014.1c-.122.851-.26,1.814-.425,2.8-7.242,31.017-3.356,65.351,10.943,96.677,4.322,9.488,8.462,16.635,13.027,22.491a62.562,62.562,0,0,0,16.656,14.542,184.577,184.577,0,0,0,19.133,9.911c6.986,3.279,14.207,6.667,20.813,10.976a80.182,80.182,0,0,1,8.762,6.906c.857.744,1.829,1.586,2.794,2.4a14.051,14.051,0,0,0,8.721,3.579C-14947-5169.081-14946.869-5169.083-14946.754-5169.088Zm22.063-56.625h0c-2.4-4.2-2.062-9.468-1.6-13.062a18.843,18.843,0,0,1,7.931-13.618,81.6,81.6,0,0,1,12.536-7.623,35.863,35.863,0,0,1,14.011-3.834c.243-.008.488-.013.729-.013a47.508,47.508,0,0,1,10.377,1.609l.083.019.01,0a47.755,47.755,0,0,0,10.534,1.628,17.277,17.277,0,0,0,5.927-.968,17.239,17.239,0,0,0,7.25-5.052,46.627,46.627,0,0,1-8.972,13.248,129.716,129.716,0,0,1-18.685,16.081c-7.194,5.08-15.439,7.1-23.414,9.059a91.654,91.654,0,0,1-16.716,2.524Zm-44.191,0h0a83.675,83.675,0,0,1-16.777-2.588h-.006c-7.969-1.951-16.208-3.969-23.408-9.053a133.706,133.706,0,0,1-18.685-16.081,44.929,44.929,0,0,1-8.972-13.251,16.6,16.6,0,0,0,7.25,5.055,17.26,17.26,0,0,0,5.922.967,48.093,48.093,0,0,0,10.553-1.629,47.644,47.644,0,0,1,10.474-1.632c.23,0,.47,0,.712.012a35.862,35.862,0,0,1,13.986,3.86,84.7,84.7,0,0,1,12.561,7.6,19.261,19.261,0,0,1,7.932,13.618,30.632,30.632,0,0,1,.289,6.746,15.321,15.321,0,0,1-1.829,6.376Z",
    transform: "translate(15122 5392)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 231, 53)",
    filter: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask-3",
    "data-name": "mask",
    d: "M205.845,4.442c-.186-1.54-.431-2.958-.616-4.128-.061-.493-.86-.37-.86.123.123,5.361,2.09,13.247-.923,18.177-4.547,7.332-14.012-.185-18.5-3.82C176.467,7.893,168.108.129,156.431.129c-12.046,0-21.879,6.162-30.606,13.863-4.241,3.759-9.342,7.579-12.107,12.631-1.6,2.9-2.827,6.285-5.961,7.948a11.692,11.692,0,0,1-3.073,1.171,11.692,11.692,0,0,1-3.073-1.171c-3.073-1.664-4.3-5.053-5.961-7.948-2.827-5.052-7.867-8.873-12.107-12.631C74.753,6.291,64.919.129,52.935.129c-11.677,0-19.974,7.764-28.517,14.664-4.486,3.635-13.951,11.152-18.5,3.82C2.907,13.684,4.874,5.8,5,.437c0-.493-.8-.616-.86-.123-.184,1.232-.369,2.649-.615,4.128-7.5,32.1-2.643,66.914,10.94,96.675,3.565,7.825,7.744,15.712,13.029,22.49a62.755,62.755,0,0,0,16.655,14.541c12.783,7.949,27.288,12.631,39.948,20.888,4.179,2.711,7.744,6.1,11.554,9.3a13.765,13.765,0,0,0,9.1,3.574c3.319.123,6.453-1.418,9.1-3.574,3.811-3.2,7.375-6.593,11.554-9.3,12.66-8.195,27.165-12.878,39.948-20.888A62.759,62.759,0,0,0,182,123.607c5.285-6.778,9.464-14.665,13.029-22.49C208.487,71.295,213.341,36.544,205.845,4.442ZM126.808,115.288c-2.213-3.882-2.151-8.749-1.6-13.062a18.856,18.856,0,0,1,7.928-13.617c7.437-5.361,17.147-11.152,26.55-11.461,9.034-.308,18.744,5.484,27.657,2.28a17.212,17.212,0,0,0,7.251-5.053,46.676,46.676,0,0,1-8.972,13.247A129.464,129.464,0,0,1,166.941,103.7c-7.068,4.991-15.119,7.024-23.416,9.057A92.175,92.175,0,0,1,126.808,115.288Zm-44.189,0A83.91,83.91,0,0,1,65.841,112.7c-8.3-2.033-16.348-4.067-23.416-9.057A132.8,132.8,0,0,1,23.742,87.561a45.027,45.027,0,0,1-8.973-13.247,16.688,16.688,0,0,0,7.252,5.053c8.912,3.2,18.622-2.588,27.656-2.28,9.342.308,19.114,6.162,26.55,11.461a19.262,19.262,0,0,1,7.928,13.617C84.77,106.539,84.832,111.407,82.619,115.288Z",
    transform: "translate(70.5 51)",
    fill: "none",
    stroke: "rgba(94,214,255,0)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Frame",
    "data-name": "Dashboard Frame",
    transform: "translate(508.948 -334)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 50,
    height: 247,
    transform: "translate(970.052 385)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 50,
    height: 247,
    transform: "translate(1275.052 385)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 33,
    height: 355,
    transform: "translate(1325.052 377) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 19,
    height: 355,
    transform: "translate(1325.052 613) rotate(90)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMask);
export default __webpack_public_path__ + "static/media/dashboard_mask.d930a274602cad37b4d0c46150106b97.svg";
export { ForwardRef as ReactComponent };